var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading && _vm.shouldShowLoading)?_c('div',{staticClass:"loading"},[_c('Preloader',{staticClass:"m-a"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }